import { mapGetters } from "vuex";
import utils from "../../utils/util";
import pageheader from "../pageheader";
import draggable from "vuedraggable";

import telematicsService from "../../api/telematics.service";

export default {
  name: "dashboard",
  components: { pageheader, draggable },
  data() {
    return {
      input: {},
      isLoading: false,
      itemsonRentCount: null,
      itemsonReservationCount: null,
      itemsOverdueCount: null,
      itemsScheduledforPickupCount: null,
      tasks: [],
      reportsArrayHome: [],
    };
  },
  async created() {
    this.getStats();
  },
  computed: {
    ...mapGetters(["roles", "permissions"]),
  },
  mounted() {
    this.input = utils.getInputContent("overview", this.roles);
    this.getReportsDynamic();
  },
  methods: {
    getReportsDynamic() {
      this.reportsArrayHome = this.permissions;
    },
    async getStats() {
      try {
        this.isLoading = true;
        let statsResponse = await telematicsService.getStats();
        if (statsResponse.isSuccess) {
          this.tasks.push(
            {
              id: 1,
              title: "<h3>Fleet <br /> Map</h3>",
              img: require("@/assets/Fleet Map.jpeg"),
              name: "Fleet Map",
              link: "/",
              externalLink: "",
              count: "",
              showcount: false,
              isComingSoon: false,
            },
            {
              id: 2,
              title: "<h3>On<br />Rent</h3>",
              img: require("@/assets/On Rent.jpeg"),
              name: "On Rent",

              count: 5887,
              link: "/on-rent",
              showcount: true,
              externalLink: "",
              isComingSoon: false,
            },
            {
              id: 3,
              title: "<h3>On <br />Reservation</h3>",
              img: require("@/assets/On Reservation.jpeg"),
              name: "On Reservation",

              count: 5210,
              link: "/on-rent?status=2",
              externalLink: "",
              showcount: true,
              isComingSoon: false,
            },
            {
              id: 4,
              title: "<h3>Overdue</h3>",
              img: require("@/assets/Overdue.jpeg"),
              name: "Overdue",
              count: 4192,
              link: "/on-rent?status=5",
              showcount: true,
              externalLink: "",
              isComingSoon: false,
            },
            {
              id: 6,
              title:
                "<h3>Analytics & <br/>Reporting <br/>Utilization Data</h3>",
              img: require("@/assets/Analytics & Reporting Utilization Data.jpeg"),
              name: "Analytics & Reporting Utilization Data",
              count: "",
              link: "/view-all-reports",
              showcount: false,
              externalLink: "",
              isComingSoon: false,
            },
            {
              id: 7,
              title: "<h3>Payment Portal</h3>",
              img: require("@/assets/Payment Portal.jpeg"),
              name: "Payment Portal",
              count: "",
              link: "",
              externalLink: "https://birchequipment.myportal.rent/#",
              showcount: false,
              isComingSoon: false,
            },

            {
              id: 8,
              title: "<h3>Rent & Purchase <br />Equipment</h3>",
              img: require("@/assets/Rent & Purchase Equipment .jpeg"),
              name: "Rent & Purchase Equipment",
              count: "",
              link: "",
              externalLink: "https://www.birchequipment.com/",
              showcount: false,
              isComingSoon: false,
            },
            {
              id: 9,
              title: "<h3>Reserve <br/> and <br/> Order</h3>",
              img: require("@/assets/Plan and Order.jpeg"),
              name: "Reserve and Order",
              count: "",
              link: "/create-planning-sheet",
              showcount: false,
              externalLink: "",
              isComingSoon: false,
            },
            {
              id: 16,
              title: "<h3>View Birch <br/>Equipment <br/>Locations</h3>",
              img: require("@/assets/View Birch Equipment Locations.jpeg"),
              name: "View Birch Equipment Locations",
              count: "",
              link: "",
              externalLink: "https://www.birchequipment.com/store-locations/",
              showcount: false,
              isComingSoon: false,
            },

            {
              id: 18,
              title: "<h3>Service Module</h3>",
              img: require("@/assets/Service Module.jpeg"),
              name: "Service Module",
              count: "",
              link: "/services",
              externalLink: "",
              showcount: false,
              isComingSoon: false,
            },

            {
              id: 19,
              title: "<h3>Customer Assets</h3>",
              img: require("@/assets/My Assets.jpeg"),
              name: "Assets",
              count: "",
              link: "/customer-owned-equipment",
              showcount: false,
              externalLink: "",
              isComingSoon: false,
            }
          );
          this.itemsonRentCount = statsResponse.data.itemsOnRent;

          this.itemsonReservationCount = statsResponse.data.itemsOnReservation;
          this.itemsOverdueCount = statsResponse.data.itemsOverdue;
          this.itemsScheduledforPickupCount =
            statsResponse.data.scheduledPickups;
          // tile name -> the stats count it displays
          const tileCounts = {
            "On Rent": this.itemsonRentCount,
            "On Reservation": this.itemsonReservationCount,
            Overdue: this.itemsOverdueCount,
            "Scheduled Pickups": this.itemsScheduledforPickupCount,
          };
          // permission -> the tiles to drop when the user does not have it
          const permissionTiles = [
            { permission: "Map", tiles: ["Fleet Map"] },
            {
              permission: "On Rent",
              tiles: [
                "On Rent",
                "On Reservation",
                "Overdue",
                "Scheduled Pickups",
              ],
            },
            {
              permission: "Reports",
              tiles: ["Analytics & Reporting Utilization Data"],
            },
            { permission: "Reserve & Order", tiles: ["Plan and Order"] },
            { permission: "Service & Maintenance", tiles: ["Service Module"] },
            { permission: "Customer Owned Equipment", tiles: ["Assets"] },
          ];
          this.tasks.map((e) => {
            if (Object.prototype.hasOwnProperty.call(tileCounts, e.name)) {
              e.count = tileCounts[e.name];
            }
            if (e.name == "Assets") {
              e.title =
                this.roles == "Customer"
                  ? "<h3>My Assets</h3>"
                  : "<h3>Customer Assets</h3>";
            }

            permissionTiles.forEach(({ permission, tiles }) => {
              if (!this.reportsArrayHome.includes(permission)) {
                this.tasks = this.tasks.filter((t) => !tiles.includes(t.name));
              }
            });
          });
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.tasks = [];
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    routeTo(item) {
      if (item.link != "") {
        this.$router.push(item.link);
      }
      if (item.externalLink != "") {
        window.open(item.externalLink, "_blank");
      }
    },
  },
};
